import { Component, Input } from '@angular/core';

/**
 * کارت پایه شیشه‌ای (Liquid Glass) برای بسته‌بندی هر بلوک محتوا در اپ.
 * tint قابل تغییر است تا کارت‌های مختلف (مثل هشدار پریود vs اطلاعات عمومی) رنگ‌بندی متفاوتی داشته باشند.
 */
@Component({
  selector: 'app-glass-card',
  standalone: true,
  templateUrl: './glass-card.component.html',
  styleUrl: './glass-card.component.scss',
})
export class GlassCardComponent {
  @Input() tint: 'light' | 'medium' | 'strong' | 'primary' | 'secondary' | 'success' | 'danger' = 'medium';
  @Input() interactive = false;
  @Input() padding: 'sm' | 'md' | 'lg' = 'md';
}
